import { CurrencySchema } from '@eigtech/currency';
import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { InvoiceSchema } from '../base/index.js';
export const ReportInvoicePaymentMadeApiSchema = {
    params: z.object({
        entityId: CornSchema,
        invoiceId: z.string(),
    }),
    body: z.object({
        amountPaid: CurrencySchema,
    }),
    headers: z.object({ requestActor: z.string() }),
    response: z.object({ invoice: InvoiceSchema.optional() }),
};
export const ReportInvoicePaymentMadeInternalApiSchema = {
    params: z.object({
        invoiceId: z.string(),
    }),
    body: z.object({
        amountPaid: CurrencySchema,
    }),
    response: z.object({ invoice: InvoiceSchema.optional() }),
};
export const ReportInvoicePaymentMadePathSchema = ReportInvoicePaymentMadeApiSchema.params;
export const ReportInvoicePaymentMadeInternalRequestSchema = ReportInvoicePaymentMadeInternalApiSchema.params.merge(ReportInvoicePaymentMadeInternalApiSchema.body);
export const ReportInvoicePaymentMadeRequestSchema = ReportInvoicePaymentMadeApiSchema.params
    .merge(ReportInvoicePaymentMadeApiSchema.headers)
    .merge(ReportInvoicePaymentMadeApiSchema.body);
export const ReportInvoicePaymentMadeResponseSchema = ReportInvoicePaymentMadeApiSchema.response;
